import { FC, PropsWithChildren } from 'react';

import { ChakraProvider as Provider } from '@chakra-ui/react';

import chakraTheme from '@/theme';

export const ChakraProvider: FC<PropsWithChildren> = ({ children }) => {
  return <Provider theme={chakraTheme}>{children}</Provider>;
};
